import { Component, Inject, OnInit } from '@angular/core';
import { AppMaterialModule } from '../../../../app-material.module';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PhotoDialogComponent } from 'app/partner/partner-orders/photo-dialog/photo-dialog.component';
import { TableModule } from 'primeng/table';
import { AppDataService, PartnerOrderService } from 'app/services';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';
import { ChatMessageTypeEnum } from 'app/models';
import { StylesStatus } from 'app/users/StylesStatus';
import { ToastModule } from 'primeng/toast';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { DisputeReasonEnum } from 'app/models/enums/dispute-reason.enum';

@Component({
  selector: 'partner-order-view',
  standalone: true,
  imports: [
    AppMaterialModule,
    CommonModule,
    TableModule,
    DialogModule,
    SidebarModule,
    ToastModule,
    MatTabGroup
  ],
  templateUrl: './partner-order-view.component.html',
  styleUrls: ['./partner-order-view.component.scss',
    '../../../../../styles/m3-defaul-material-theme.scss']
})
export class PartnerOrderViewComponent implements OnInit {
  protected readonly ChatMessageTypeEnum = ChatMessageTypeEnum;
  orderTransactionDate: string = '-';
  orderTransactionTime: string = '-';
  orderDate: string = '';
  orderStartTime: string = '';
  orderEndTime: string = '';
  chatSubject: string = '';
  products: Array<any> = [];
  payments: Array<any> = [];
  messages: Array<any> = [];
  timelineRows: Array<any> = [];

  productCols: any[] = [
    { field: 'OrderId', header: 'Order ID', width: '90px', disableSort: true },
    { field: 'ProductName', header: 'Name', width: '200px', disableSort: true },
    { field: 'Price', header: 'Price', width: '200px', disableSort: true },
    { field: 'Quantity', header: 'Qty', width: '200px', disableSort: true },
    { field: 'TotalCost', header: 'Total', width: '200px', disableSort: true },
    { field: 'Notes', header: 'Customer Notes', width: '200px', disableSort: true },
  ];

  paymentsCols: any[] = [
    { field: 'Id', header: 'TRXN', width: '90px', disableSort: true },
    { field: 'PaymentMethod', header: 'MID', width: '200px', disableSort: true },
    { field: 'PartnerTrxnId', header: 'Partner TRXN ID', width: '90px', disableSort: true },
    { field: 'XpressStatus', header: 'Xpress Status', width: '150px', disableSort: true },
    { field: 'PartnerStatus', header: 'Partner Status', width: '150px', disableSort: true },
  ];

  rowsPerPage: number = 20;
  rowsPerPageOptions: Array<number> = [20, 50, 100];
  totalRecords: number = -1;

  first: number = 0;
  sortField: string | string[] = '';
  loading: boolean = false;

  isFulfilled: boolean = true;
  fulfilledCount: number = 0;
  missingCount: number = 1;
  deducted: number = 90.00;
  showDisputeSidebar = false;
  discardConfirmDialog = false;
  disputeDescription: string = '';
  submitDisputeConfirmDialog: boolean = false;
  disputeReasonId: number = 0;
  otherReason: string = '';

  constructor(
    private messageService: MessageService,
    private partnerOrderService: PartnerOrderService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PartnerOrderViewComponent>,
    @Inject(MAT_DIALOG_DATA) public order: any) {
  }

  ngOnInit(): void {
    const orderTransaction = this.order.TransactionDate ? this.order.TransactionDate.split(', ') : [];
    const orderStart = this.order.DeliveryDateFrom ? this.order.DeliveryDateFrom.split(', ') : [];
    const orderEnd = this.order.DeliveryDateTo ? this.order.DeliveryDateTo.split(', ') : [];

    this.orderTransactionDate = orderTransaction[0] ?? '-';
    this.orderTransactionTime = orderTransaction[1] ?? '-';

    this.orderDate = orderStart[0] ?? '-';
    this.orderStartTime = orderStart[1] ?? '-';
    this.orderEndTime = orderEnd[1] ?? '-';
  }

  onTabChange(ev: MatTabChangeEvent) {
    switch (ev.index) {
      case 1: this.getProducts(); break;
      case 2: this.getPayments(); break;
      case 3: this.getMessages(); break;
      case 4: this.getTimeline(); break;
    }
  }

  getProducts() {
    this.loading = true;

    const dto = {
      OrderId: this.order.Id.slice(3),
      IsFulfilled: this.isFulfilled,
    };

    this.partnerOrderService.getOrderItems(dto, this.messageService)
        .then(data => {
          this.loading = false;

          if (!data || !data.Success) {
            this.messageService.add({key: 'modal', severity: 'error', summary: 'Error', detail: 'Unable to load products. Please try again.' });
            return;
          }

          //todo temporary for testing
          if (!this.isFulfilled) {
            this.fulfilledCount = this.products.length;
            this.products = this.products.slice(0, 2);
            this.missingCount = this.products.length;
          } else {
            this.products = data.Products;
            this.fulfilledCount = this.products.length;
            this.missingCount = 2;
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
  }

  getPayments() {
    this.loading = true;
    const dto = {
      OrderId: this.order.Id.slice(3),
    };
    this.partnerOrderService.getPayments(dto, this.messageService)
        .then(data => {
          this.loading = false;

          if (!data || !data.Success) {
            this.messageService.add({key: 'modal', severity: 'error', summary: 'Error', detail: 'Unable to load payment details. Please try again.' });
            return;
          }
          this.payments = data.Payments;
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
  }

  getMessages() {
    this.loading = true;
    const dto = {
      OrderId: this.order.Id.slice(3),
    };
    this.partnerOrderService.getMessages(dto, this.messageService)
        .then(data => {
          this.loading = false;
          if (!data || !data.Success) {
            this.chatSubject = 'No messages for this order';
            this.messageService.add({key: 'modal', severity: 'error', summary: 'Error', detail: 'Unable to load messages. Please try again.' });
            return;
          }
          this.chatSubject = data.ChatSubject;
          this.messages = data.Messages;
          if (data.Messages.length === 0) {
            this.chatSubject = 'No messages for this order';
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
  }

  getTimeline() {
    this.loading = true;
    const dto = {
      OrderId: this.order.Id.slice(3),
    };

    this.partnerOrderService.getOrderHistory(dto, this.messageService)
        .then(data => {
          this.loading = false;
          if (!data || !data.Success) {
            this.messageService.add({key: 'modal', severity: 'error', summary: 'Error', detail: 'Unable to load timeline. Please try again.' });
            return;
          }
          this.timelineRows = data.Checkpoints;
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
  }

  swapTables(table: string) {
    this.isFulfilled = table === 'fulfilled';
    this.getProducts();
  }

  openDisputeSidebar() {
    this.dialogRef.close(this.products);
  }

  closeDisputeSidebar() {
    this.discardConfirmDialog = true;
  }

  submitDispute() {
    this.submitDisputeConfirmDialog = false;
    this.showDisputeSidebar = false;
  }

  cancelDiscard() {
    this.discardConfirmDialog = false;
  }

  discardConfirm() {
    this.discardConfirmDialog = false;
    this.showDisputeSidebar = false;
  }

  cancelSubmitDispute() {
    this.submitDisputeConfirmDialog = false;
  }

  isSubmitDisabled() {
    const anyProductsSelected = this.products.some(x => x.checked);
    if (!anyProductsSelected || !this.disputeReasonId || (this.disputeReasonId === DisputeReasonEnum.Other && !this.otherReason)) {
      return true;
    }
    return false;
  }

  viewProof() {
    if (!this.order.ProofOfDelivery || this.order.ProofOfDelivery === '-') {
      return;
    }

    this.dialog.open(PhotoDialogComponent, {
      data: { photoUrl: this.order.ProofOfDelivery, deliveryDate: this.order.DeliveryDateTo },
      panelClass: 'photo-dialog-container',
      maxWidth: '95vw',
      maxHeight: '95vh'
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getStatusStyles(status: string): StylesStatus {
    let backgroundColor: string = '#FBBF7F';
    let textColor: string = '#A45400';
    if (status === 'PAID' || status === 'SUCCEEDED' || status === 'COMPLETED') {
      backgroundColor = '#1CBA70';
      textColor = '#FFF';
    } else if (status === 'PENDING' || status === 'FAILED') {
      backgroundColor = '#CE4C30';
      textColor = '#FFF';
    }
    return {
      backgroundColor,
      color: textColor
    };
  }
}
